import moment from 'moment';
import { PropsWithChildren, ReactNode, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Box, Flex } from 'reflexbox';

import { Avatar } from './Avatar';
import { Skeleton } from './Skeleton';
import { Paragraph } from './Text';
import { UserRow } from './UserRow';

type AuthorUser = {
	id: string;
	firstName: string;
	lastName: string;
};

const LinkOrDiv = (props: PropsWithChildren<{ to: string; disableLink?: boolean }>) => {
	if (props.disableLink) {
		return <>{props.children}</>;
	} else {
		return <Link to={props.to}>{props.children}</Link>;
	}
};

export const Author = Skeleton(
	function Author(props: {
		user: AuthorUser;
		createdAt: Date;
		description: string;
		avatarIcon?: ReactNode;
		avatarColor?: string;
		disableLink?: boolean;
	}) {
		const subtitle = useMemo(() => {
			const formattedDate = moment(props.createdAt).format('LL');
			return `${props.description}: ${formattedDate}`;
		}, [props.createdAt, props.description]);

		return (
			<LinkOrDiv to={`/users/${props.user.id}`} disableLink={props.disableLink}>
				<UserRow
					user={props.user}
					contrast="low"
					avatarProps={{ color: props.avatarColor, icon: props.avatarIcon }}
					subtitle={subtitle}
				/>
			</LinkOrDiv>
		);
	},
	function AuthorSkeleton() {
		return (
			<Flex alignItems="center">
				<Avatar.Skeleton size={40} mr={2} />
				<Box>
					<Paragraph.Skeleton lines={1} mb={1} />
					<Paragraph.Skeleton lines={1} />
				</Box>
			</Flex>
		);
	},
);
